/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


/* Content blur body class ----------------------- */
;(function(window, $) {
  $('.Header__MainNav a').parent().on('mouseenter', function() {
    $('body').addClass('blur-content')
  })
  $('.Header__MainNav').on('mouseleave', function() {
    $('body').removeClass('blur-content')
  })
  $('window').on('resize', function() {
    $('body').removeClass('blur-content')
  })
  $('body').on('click', '.ProductForm__AddToCart', function() {
    $( ".Header__Icon--flag" ).removeClass( "cart-empty-display-flag" );
    $( ".header-flag-div" ).removeClass( "cart-empty-reverse-row" );
    $( ".the-cart-icon" ).removeClass( "cart-empty-hidden" );
  });
  $('body').on('click', '.CartItem__Remove, .QuantitySelector__Button', function() {
    console.log("removed");
    
    setTimeout(function () {
      console.log("test: "+ $('.Cart__Empty').length);
      if($('.Cart__Empty').length){
        $( ".Header__Icon--flag" ).addClass( "cart-empty-display-flag" );
        $( ".header-flag-div " ).addClass( "cart-empty-reverse-row" );
        $( ".the-cart-icon" ).addClass( "cart-empty-hidden" );
      }
    }, 2500);
    
  });  
  
})(window, jQuery)


// Event Tracking

document.addEventListener("DOMContentLoaded", () => {
  window.dataLayer = window.dataLayer || [];

  const dataVariables = (data) => {
    console.log(data.dataset.event, data.dataset.siteComponent, data.dataset.componentLabel);
    dataLayer.push({
      'event': data.dataset.event,
      'siteComponent': data.dataset.siteComponent,
      'componentLabel': data.dataset.componentLabel
    }); 
  }

  const links = document.querySelectorAll('.event-tracking');
  if (links.length > 0) {
    links.forEach(link => {
      link.addEventListener('click', () => {
        dataVariables(link)
      });
    });
  }

  const newsletter = document.getElementById('footer-newsletter');
  if (newsletter !== null) {
    const button = newsletter.querySelector('.Form__Submit');
    newsletter.addEventListener('submit', () => {
      dataVariables(button)
    });
  }

});

$(document).ready(function () {
  // Step 1: Bind click event to the first element
  $("div.Collapsible.sidemenu-search").on("click", function () {
    // Step 2: Click the button to close the drawer
    $('button.Drawer__Close[data-action="close-drawer"]').click();
    // Step 3: After a delay of 500 milli-second, click the search icon/link
    setTimeout(function () {
      console.log("Attempting to click search icon");
      var clickEvent = new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      });

      var element = document.querySelector(
        'a.Header__Icon[data-action="toggle-search"]'
      );
      if (element) {
        element.dispatchEvent(clickEvent);
      }
    }, 500);
  });

});